import React from "react";
import Logo from "../images/logo/Logo.png";

export const HomeContent = () => {
  return (
    <div id="content">
      <div id="home" className="menu-content">
        <div className="logo">
          <img src={Logo} alt="Web App Logo" />
        </div>
        <div className="web-details">
          <h2>TechShoor Agri</h2>
          <p>Farmer's solution for farm's growth.</p>
        </div>
      </div>
    </div>
  );
};
